<template>
    <div class="bank-reconciliation-paired-list" :style="{ height: listHeight + 'px', maxHeight: listHeight + 'px' }">
        <Molded class="bank-reconciliation-paired-list-card" :paddingLeft="0" :paddingRight="0">
            <div class="bank-reconciliation-paired-list-body">
                <div v-if="statementItems.length == 0" class="bank-reconciliation-paired-list-empty">
                    {{ emptyMessage }}
                </div>
                <div v-for="group in groupedStatementItems" :key="group.key"
                    class="bank-reconciliation-paired-list-group"
                    :class="{ 'bank-reconciliation-paired-list-group-multi': group.items.length > 1 }">
                    <div class="bank-reconciliation-paired-list-group-label" v-if="group.items.length > 1">
                        Grupo de {{ group.items.length }} itens do extrato · Total: {{ group.total | currency }}
                    </div>
                    <b-row class="no-gutters bank-reconciliation-paired-list-row" v-for="(item, index) in group.items"
                        :key="item.id">
                        <b-col sm="6" class="bank-reconciliation-paired-list-col">
                            <ReconciliationImportedRow :item="item" @toggle-select="$emit('toggle-select', $event)"
                                @delete="$emit('delete', $event)" />
                        </b-col>
                        <div class="bank-reconciliation-paired-list-connector">
                            <i class="fa-solid fa-arrow-right"></i>
                        </div>
                        <b-col sm="6" class="bank-reconciliation-paired-list-col">
                            <ReconciliationMatchCard :statementItem="item" :recordItem="findRecordItem(item)"
                                :condensed="index > 0" @conciliar="$emit('conciliar', $event)"
                                @desfazer="$emit('desfazer', $event)"
                                @force-reconcile="$emit('force-reconcile', $event)" @search="$emit('search', $event)"
                                @create="$emit('create', $event)" @link-more="$emit('link-more', $event)" />
                        </b-col>
                    </b-row>
                </div>
            </div>
        </Molded>
    </div>
</template>

<script>
import Molded from "@/ui/layout/Molded";

import ReconciliationImportedRow from "./ReconciliationImportedRow.vue";
import ReconciliationMatchCard from "./ReconciliationMatchCard.vue";

export default {
    name: "BankReconciliationPairedList",
    components: {
        Molded,
        ReconciliationImportedRow,
        ReconciliationMatchCard,
    },
    props: {
        statementItems: {
            type: Array,
            default: () => [],
        },
        record: {
            type: Array,
            default: () => [],
        },
        listHeight: {
            type: Number,
            default: 300,
        },
        emptyMessage: {
            type: String,
            default: "Nenhum lançamento encontrado.",
        },
    },
    computed: {
        groupedStatementItems() {
            let groups = [];
            let indexByKey = {};

            this.statementItems.forEach((item) => {
                let key = item.pairId ? ('pair-' + item.pairId) : ('single-' + item.id);
                if (indexByKey[key] == undefined) {
                    indexByKey[key] = groups.length;
                    groups.push({ key, items: [] });
                }
                groups[indexByKey[key]].items.push(item);
            });

            groups.forEach((group) => {
                group.total = group.items.reduce((accumulator, item) => accumulator + item.value, 0);
            });

            return groups;
        },
    },
    methods: {
        findRecordItem(item) {
            return this.record.find((recordItem) => recordItem.id == item.pairId) || null;
        },
    },
};
</script>

<style scoped>
.bank-reconciliation-paired-list {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.bank-reconciliation-paired-list-card {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.bank-reconciliation-paired-list-body {
    width: 100%;
    max-width: 100%;
    min-height: 0;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.bank-reconciliation-paired-list-body::-webkit-scrollbar {
    width: 6px;
}

.bank-reconciliation-paired-list-body::-webkit-scrollbar-track {
    background-color: var(--bg-base);
    border-radius: 20px;
}

.bank-reconciliation-paired-list-body::-webkit-scrollbar-thumb {
    background-color: var(--text-muted);
    border-radius: 20px;
}

.bank-reconciliation-paired-list-group {
    margin-bottom: 10px;
}

.bank-reconciliation-paired-list-group-multi {
    border: 1px solid var(--color-brand);
    border-radius: 12px;
    padding: 10px 2px;
    background: var(--bg-elevated);
}

.bank-reconciliation-paired-list-group-multi .bank-reconciliation-paired-list-row:not(:last-child) {
    margin-bottom: 8px;
}

.bank-reconciliation-paired-list-group-label {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 14px 8px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--color-brand);
}

.bank-reconciliation-paired-list-row {
    position: relative;
    align-items: stretch;
}

.bank-reconciliation-paired-list-col {
    min-width: 0;
    display: flex;
    padding: 0 14px;
}

.bank-reconciliation-paired-list-connector {

    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: var(--bg-base);
    border: 1px solid var(--border-color);
    color: var(--color-brand);
    font-size: 10px;
    z-index: 1;
}

.bank-reconciliation-paired-list-empty {
    padding: 32px 16px;
    text-align: center;
    color: var(--text-muted);
    font-size: 13px;
}
</style>
